<template>
  <div class="mt-n7 picker">
    <v-speed-dial v-model="fab" direction="right" open-on-hover class="py-1">
      <template v-slot:activator>
        <v-btn small v-model="fab" color="black" dark fab @click="insertEditable(idx)" title="insert new block">
          <v-icon v-if="fab">mdi-pencil</v-icon>
          <v-icon v-else>mdi-plus</v-icon>
        </v-btn>
      </template>
      <v-btn fab dark x-small color="black" title="insert code" @click="insertEditable(idx,['code-container'],1)">
          <v-icon>mdi-code-braces</v-icon>
      </v-btn>
      <v-btn fab dark x-small color="black" title="insert divider" @click="insertEditable(idx,[],0,'<hr/>')">
          <v-icon>mdi-window-minimize</v-icon>
      </v-btn>
      <v-btn fab dark x-small color="black" title="insert media" @click="insertEditable(idx,[],0,defaultImg)">
          <v-icon>mdi-image</v-icon>
      </v-btn>
      <v-speed-dial v-model="fabMore" direction="right" open-on-hover>
        <template v-slot:activator>
          <v-btn x-small v-model="fabMore" color="grey darken-4" dark fab  class="mr-0">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <v-btn fab dark x-small color="grey darken-4" class="ml-0" title="insert heading" @click="insertEditable(idx,[],0,'<h1>Heading</h1>')">
            <v-icon>mdi-format-header-1</v-icon>
        </v-btn>
        <v-btn fab dark x-small color="grey darken-4" title="insert sub-heading" @click="insertEditable(idx,[],0,'<h3>Sub-heading</h3>')">
            <v-icon>mdi-format-header-2</v-icon>
        </v-btn>
        <v-btn fab dark x-small color="grey darken-4" title="insert link" @click="insertEditable(idx,[],0,defaultLink)">
            <v-icon>mdi-link</v-icon>
        </v-btn>
        <v-btn fab dark x-small color="grey darken-4" title="insert quote block" @click="insertEditable(idx,[],0,'<blockquote>&quot;...&quot;</blockquote>')">
            <v-icon>mdi-format-quote-close</v-icon>
        </v-btn>
        <v-btn fab dark x-small color="grey darken-4" title="insert list" @click="insertEditable(idx,[],0,'<ul><li>...</li><li>...</li></ul>')">
            <v-icon>mdi-format-list-bulleted</v-icon>
        </v-btn>
        <v-btn fab dark x-small color="grey darken-4" title="insert text paragraph" @click="insertEditable(idx,[],0,'<p>This is paragraph with a bunch of shittext in it. I had coffee and then beer. All words and no code makes Carol a dull girl. This is paragraph with a bunch of shittext it is! This is paragraph with a bunch of shit-text in it. Wow, really?</p>')">
            <v-icon>mdi-format-paragraph</v-icon>
        </v-btn>
      </v-speed-dial>
    </v-speed-dial>
</div>
</template>

<script>
export default {
  name: 'EditableMenu',
  data: () => ({
    fab: false,
    fabMore: false,
    defaultImg: '<img src="//placekitten.com/g/200/300" />',
    defaultLink: '<a href="//">linky</a>'
  }),
  props: {
    insertEditable: Function,
    idx: { 
      type: Number,
      default: 0
    }
  }
}
</script>
